import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo6/libertador.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo6 } from "../../../routes/Module6";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo6/Actividad 6.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo6.content[0];
  const infoAct = modulo6.content[0].activities[5];
  const crumbs = [
    {
      title: modulo6.title,
      url: "/" + modulo6.url,
    },
    {
      title:
        modulo6.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo6.content[0].activities[6].name}`,
    linkNext: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[6].path}`,
    titlePrev: `${modulo6.content[0].activities[4].name}`,
    linkPrev: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo6.color,
    title: `${modulo6.title} - ${infoAct.name}`,
    name: modulo6.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo6.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul className="my-4">
        <li>
          Observa la imagen y lee el siguiente texto con ayuda de tu maestro,
          maestra o familiar.
        </li>
      </ul>

      <Card>
        <div className="row my-3 align-items-center">
          <div className="col-md-6 col-xs-12">
            <img src={Imagen1} alt="Libertador" className="img-fluid" />
          </div>
          <div className="col-md-6 col-xs-12">
            <p className="fs-5 p-4 p-md-0">
              José de San Martín fue un general argentino que llegó al Perú en
              1820 para colaborar con la lucha por la independencia del Perú. Él
              mismo participó en la creación de la primera bandera y el primer
              escudo del Perú. En el año 1821, San Martín proclamó oficialmente
              la independencia del Perú, pero las luchas siguieron durante
              varios años más hasta que fuimos realmente independientes de
              España.
            </p>
          </div>
        </div>
      </Card>

      <ul className="mb-4 mt-5">
        <li>
          Ahora reflexiona con un compañero, compañera o familiar y escribe tus
          respuestas a las siguientes preguntas:
        </li>
      </ul>
      <div className="row">
        <div className="col-md-10 col-12">
          <p>¿Quién aparece en la imagen?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>¿Qué está haciendo?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>
            ¿La bandera que aparece en la imagen es la misma que usamos ahora?
            ¿En qué se parece y en qué se diferencia?
          </p>
          <textarea className="form-control mb-4" rows={3} />
          <p>¿Te gusta la primera bandera que tuvo el Perú?</p>
          <textarea className="form-control mb-4" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea la primera indicación. Observen la imagen y lean el texto. Pida
          que describan la imagen. Lea la siguiente indicación. Ayude a
          responder las preguntas y dialoguen sobre ellas. El diálogo debe
          destacar la creación o diseño de los símbolos nacionales por parte de
          San Martín y la comparación con la bandera y el escudo actuales.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
